<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.faculty_Application_Records')"></pageTitle>
        <myTableFilter
          @submit="handleSubmit"
          :show="{faculty_name: true,contact_phone: true,renewal_time: true,
                email: true,schoolStatus: true,statusText: statusText}"
        />

        <myTable ref="table" :columns="columns" requestUrl="faculty/list" :showPage="true">
          <template v-slot:detail="{ data }">
            <!-- <a @click="handleClick(data.row)">{{ $t("detail") }}</a> -->
            <Icon
              class="cursor_p"
              @click="handleClick(data.row)"
              type="md-create"
              size="24"
              color="#1F8FC8"
            />
          </template>
          <template v-slot:status="{ data }">
            <div class="df_center">
              <div :class="statusText[data.row.status].class">{{ statusText[data.row.status].text }}</div>
            </div>
          </template>
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
export default {
  name: "",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      statusText: {
        0: { value: "", text: "", class: "blue" },
        1: { value: "", text: "", class: "green" },
        2: { value: "", text: "", class: "grey" },
        3: { value: "", text: "", class: "grey" },
        4: { value: "", text: "", class: "grey" },
      },
      columns: [
        {
          title: this.$t("faculty.id"),
          key: "teacher_id",
          align: "center"
        },
        {
          title: this.$t("faculty.name"),
          key: "teacher_cname",
          align: "center"
        },
        {
          title: this.$t("contact_mobile"),
          key: "contact_mobile",
          align: "center"
        },
        {
          title: this.$t("teacher_record.email"),
          key: "teacher_email",
          align: "center"
        },
        {
          title: this.$t("teacher_record.renewal_time"),
          key: "renewal_time",
          align: "center"
        },
        {
          title: this.$t("teacher_record.status"),
          key: "status",
          align: "center",
          slot: "status"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "detail"
        }
      ]
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading();
      this.$request.sendPost(
        "teacher/before-list",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          data.status.forEach((e, i) => {
            this.statusText[i].text = e.value;
            this.statusText[i].value = e.key;
          });
        }
      );
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleClick (item) {
      this.$base.linkTo("/faculty/record_detail", {
        id: item.teacher_id
      });
    }
  }
};
</script>

<style scoped>
.blue {
  background-color: var(--green_four);
  color: #fff;
  border-radius: 20px;
  padding: 5px 15px;
}
.green {
  background-color: var(--blue_one);
  color: #fff;
  border-radius: 20px;
  padding: 5px 15px;
}
.grey {
  background-color: #ccc;
  color: #fff;
  border-radius: 20px;
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/faculty/record/record.vue